module.exports = __webpack_public_path__ + "img/andre.aa208d0a.png";